// extracted by mini-css-extract-plugin
export default {"container":"mainFuture_container__J5USB"};